import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import { STATS, WHY_POINTS } from '../constants/content';
import { COMPANY_NAME, SITE_NAME, SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function AboutPage() {
  return (
    <main>
      <section className="policy__hero">
        <div className="shell">
          <p className="policy__crumbs">
            <Link to="/">Home</Link>
            <span aria-hidden="true"> / </span>
            <span>About Us</span>
          </p>
          <h1>About {SITE_NAME}</h1>
          <p className="policy__updated">
            Certified accounting software experts helping small businesses since 2020
          </p>
        </div>
      </section>

      <section className="section">
        <div className="shell about">
          <div className="about__copy">
            <h2>Experts in the software and the books behind it</h2>
            <p>
              {COMPANY_NAME} runs {SITE_NAME} for the accounting software problems that
              general IT support cannot solve. Our experts understand both the software and the
              accounting — because a report that will not balance is rarely “just a glitch.”
            </p>
            <p>
              We repair accounting data files, clear reconciliations, fix payroll and year-end
              issues, unblock network sharing, and supply genuine licences for US small
              businesses and the accountants who support them.
            </p>
            <p>
              Every case follows the same path: diagnose on a copy, quote a flat fee,
              repair, test, then explain what changed so it does not return.
            </p>
            <div className="section__actions" style={{ justifyContent: 'flex-start' }}>
              <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
                <Icon name="phone" size={18} />
                Call {SUPPORT_PHONE_LABEL}
              </a>
              <button type="button" className="btn btn--green-line" onClick={openZohoChat}>
                <Icon name="chat" size={18} />
                Live Chat
              </button>
            </div>
          </div>

          <div className="about__side">
            <div className="stats stats--stack">
              {STATS.map((stat) => (
                <div className="stat" key={stat.label}>
                  <strong>{stat.value}</strong>
                  <span>{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section section--mint">
        <div className="shell">
          <header className="section__head">
            <p className="kicker">How we work</p>
            <h2>The standards we hold ourselves to</h2>
          </header>
          <div className="grid grid--2">
            {WHY_POINTS.map((point) => (
              <article className="card" key={point.title}>
                <span className="card__icon">
                  <Icon name={point.icon} size={22} />
                </span>
                <h3>{point.title}</h3>
                <p>{point.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
